/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiActiveCustomersTrendPointFromJSON, ApiActiveCustomersTrendPointToJSON, } from './ApiActiveCustomersTrendPoint';
export function ApiActiveCustomersTrendResponseFromJSON(json) {
    return ApiActiveCustomersTrendResponseFromJSONTyped(json, false);
}
export function ApiActiveCustomersTrendResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'points': !exists(json, 'points') ? undefined : (json['points'].map(ApiActiveCustomersTrendPointFromJSON)),
    };
}
export function ApiActiveCustomersTrendResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'points': value.points === undefined ? undefined : (value.points.map(ApiActiveCustomersTrendPointToJSON)),
    };
}
